import isoFetch from 'isomorphic-fetch';
import { computeBodyAndOptions, joinUrl, hasQuery, mergeOptions, serializeQuery, upgradeError, upgradeResponse } from './helpers';
export default class Fetcher {
  constructor(baseUrl, options = {}) {
    this._baseUrl = baseUrl;
    this._options = mergeOptions({
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      method: 'GET',
      timeout: 0
    }, options);
  }
  setOptions(newOptions = {}) {
    this._options = mergeOptions(this._options, newOptions);
    return this;
  }
  get endpoint() {
    return this._baseUrl;
  }
  get options() {
    return {
      ...this._options
    };
  }
  fetch(url, fetchOptions = {}) {
    const queryString = serializeQuery(fetchOptions.params || {});
    const queryUrl = joinUrl(this._baseUrl, url) + (queryString ? hasQuery(url) && '&' || '?' : '') + queryString;
    const queryOptions = mergeOptions(this._options, fetchOptions);
    const shouldUpgradeResponse = fetchOptions.method !== 'HEAD';
    return isoFetch(queryUrl, queryOptions).then(response => {
      const contentLength = response.headers.get('content-length');
      const isNoContentResponse = response.status === 204;
      if (shouldUpgradeResponse && !isNoContentResponse && (contentLength === undefined || contentLength === null || contentLength > 0)) return upgradeResponse(response);
      return response;
    }).then(response => {
      return Promise.resolve(response);
    }, error => {
      const err = upgradeError(error);
      return Promise.reject(err);
    });
  }
  head(path, options = {}) {
    return this.fetch(path, {
      ...options,
      method: 'HEAD'
    });
  }
  get(path, options = {}) {
    return this.fetch(path, {
      ...options,
      method: 'GET'
    });
  }
  put(path, body, options = {}) {
    return this.fetch(path, {
      ...computeBodyAndOptions(body, options),
      method: 'PUT'
    });
  }
  patch(path, body, options = {}) {
    return this.fetch(path, {
      ...computeBodyAndOptions(body, options),
      method: 'PATCH'
    });
  }
  delete(path, body, options = {}) {
    return this.fetch(path, {
      ...computeBodyAndOptions(body, options),
      method: 'DELETE'
    });
  }
  post(path, body, options = {}) {
    return this.fetch(path, {
      ...computeBodyAndOptions(body, options),
      method: 'POST'
    });
  }
}